module.exports = __webpack_public_path__ + "static/media/QPPQ_journal_catalogue.690ba9d8.pdf";